import { render, staticRenderFns } from "./ErrorField.vue?vue&type=template&id=2bf653ac&"
import script from "./ErrorField.vue?vue&type=script&lang=ts&"
export * from "./ErrorField.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports